import React, { useContext } from "react";

import { LayoutContext } from "common/contexts";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

const ContactUs = ({ isPaymentGuideline, isRefundPolicy }) => {
  const { locationRouter } = useContext(LayoutContext);

  return (
    <>
      <section id="contact-us">
        <div className="container">
          <Title
            text={"Contact Us"}
            className="mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800"
          />
          {isRefundPolicy ? (
            <div className="mb-6">
              <p className="mb-4">
                Should you have any queries regarding service quality and refund
                requests, please email us via: compliance@bbcincorp.com. We will
                do our best to support you with your queries.
              </p>
              <p>You can also contact us at the following address:</p>
            </div>
          ) : (
            locationRouter !== "sg" &&
            locationRouter !== "hk" &&
            !isPaymentGuideline && (
              <p className={"mb-6 lg:mb-10"}>
                If you have any questions about this Agreement, please contact
                us by email or regular mail at the following address:
              </p>
            )
          )}
          <div
            className={`${
              locationRouter === "sg" || locationRouter === "hk"
                ? "lg:grid-cols-1"
                : "lg:grid-cols-2"
            }  grid gap-y-6 lg:gap-x-[30px] lg:gap-y-0`}
          >
            {locationRouter !== "sg" && (
              <div className="grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6">
                <Title
                  text="BBCIncorp Limited in Hong Kong"
                  className="text-2xl font-semibold leading-9 text-bbc-brand-700"
                />
                <p>
                  Registered No: 2508698
                  <br />
                  D-U-N-S Number 664611652.
                </p>
                <div className="flex auto-rows-auto items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/location-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <a
                    className="block hover:text-bbc-brand-600"
                    href="https://goo.gl/maps/adod2kPo4Ht2GXXH9"
                    rel="nofollow noreferrer"
                    target="_blank"
                  >
                    Room 9, 4F, Beverley Commercial Centre, 87-105 Chatham Road
                    South, Tsim Sha Tsui, Kowloon, Hong Kong
                  </a>
                </div>
                <div className="flex items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/earth-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <a
                    className="block hover:text-bbc-brand-600"
                    href="mailto:service@bbcincorp.com"
                    rel="nofollow"
                  >
                    service@bbcincorp.com
                  </a>
                </div>
                <div className="flex items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/phone-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <a
                    className="block hover:text-bbc-brand-600"
                    href="tel:+85281928666"
                    rel="nofollow"
                  >
                    (+852) 8192 8666
                  </a>
                </div>
              </div>
            )}
            {locationRouter !== "hk" && (
              <div className="grid h-full gap-y-4 rounded-md bg-white px-4 py-6 shadow-[0px_9px_24px_rgba(196,196,196,0.25)] lg:grid-rows-[auto_52px_1fr_auto_auto] lg:px-6">
                <Title
                  text="BBCIncorp Pte. Ltd. in Singapore"
                  className="text-2xl font-semibold leading-9 text-bbc-brand-700"
                />
                <p
                  className={`${
                    locationRouter === "sg" || locationRouter === "hk"
                      ? "hidden"
                      : "hidden lg:block"
                  }`}
                ></p>
                <div className="flex items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/location-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <p>68 Circular Road, #02-01 Singapore (049422), Singapore</p>
                </div>
                <div className="flex items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/earth-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <a
                    className="block hover:text-bbc-brand-600"
                    href="mailto:service@bbcincorp.com"
                    rel="nofollow"
                  >
                    service@bbcincorp.com
                  </a>
                </div>
                <div className="flex items-center gap-x-2.5">
                  <Img
                    src="/assets/icons/phone-white.svg"
                    width={48}
                    height={48}
                    wrapper={{ className: "flex-none w-12" }}
                  />
                  <a
                    className="block hover:text-bbc-brand-600"
                    href="tel:+6531381666"
                    rel="nofollow"
                  >
                    (+65) 3138 1666
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

ContactUs.defaultProps = {
  isPaymentGuideline: false,
  isRefundPolicy: false,
};

export default ContactUs;
